import type { SxProps, Theme } from "@mui/material/styles";

export const paper: SxProps<Theme> = (theme) => ({
  borderRadius: 3,
  p: theme.spacing(1),
  minWidth: 320,
});

export const actions: SxProps<Theme> = {
  px: 2,
  pb: 2,
  gap: 1,
};
